<template>
  <div>
    <div class="desktop-nav">
      <ShareModal ref="shareDesign" />
      <base-button
        v-if="showBasketButton"
        class="xs:w-full xs:h-full"
        icon="cart-icon"
        @click.native="redirect('basket', 'always', 'instant')"
      >
        {{ $t('summary.addToBasket') }}
      </base-button>
      <base-button
        class="border"
        color="white"
        icon="share-icon"
        @click.native="share"
      >
        {{ $t('share.sharedesign') }}
      </base-button>
    </div>

    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-if="desktopView" class="product--details" v-html="htmlContent"></div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import Redirect from '../mixins/redirect';
import { useProductInfoStore } from '../store-pinia/product-info';
import ShareModal from '../components/ShareModal.vue';
import isMobile from '../../utils/is-mobile';
import { useRouterStore } from '@/store-pinia/router';
import throttle from 'lodash/throttle';

export default {
  name: 'BelowCreator',
  components: { ShareModal },
  mixins: [Redirect],
  data: () => ({
    desktopView: true,
    handleResize: null
  }),
  computed: {
    ...mapState(useProductInfoStore, ['htmlContent']),
    showBasketButton: () => useRouterStore().currentRoute !== 'basket',
    productInfoStore() {
      return useProductInfoStore();
    }
  },
  watch: {
    '$route.params.articleNumber': {
      immediate: true,
      handler(articleNumber) {
        if (articleNumber) {
          this.loadHtmlContent(articleNumber);
        }
      }
    }
  },
  created() {
    // Initialize resize handler with component instance binding
    this.handleResize = throttle(
      () => {
        this.desktopView = !isMobile();
      },
      200,
      { leading: true, trailing: true }
    );
  },
  mounted() {
    this.desktopView = !isMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Clean up event listener and cancel any pending throttled calls
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
      this.handleResize.cancel();
    }
  },
  methods: {
    share() {
      this.$refs.shareDesign.share();
    },
    async loadHtmlContent(articleNumber) {
      await this.productInfoStore.fetchProductInfo(articleNumber);

      if (window.StateManager) {
        window.StateManager.addPlugin('.tab-menu--product', 'swTabMenu', [
          's',
          'm',
          'l',
          'xl'
        ]);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@screen md {
  .desktop-nav {
    @apply flex flex-row-reverse py-4;
    gap: 1rem;
  }
}
@screen xs {
  .desktop-nav {
    display: none;
  }
}
</style>
